<template>
  <section class="bg-[#f5f2ec] px-4 py-10 sm:px-5 md:py-24">
    <div class="mx-auto max-w-7xl">
      <div class="mb-6 md:mb-10">
        <div>
          <p class="section-kicker">Press & Recognition</p>
          <h2 class="section-title max-w-3xl">
            Published features and certifications.
          </h2>
          <div class="section-rule"></div>
        </div>
      </div>

      <div v-if="loading && !projectsl.length" class="grid gap-4 md:grid-cols-4 md:gap-5">
        <div
          class="h-72 soft-loader sm:h-96"
          :class="featureGridClass(index - 1)"
          v-for="index in 3"
          :key="`feature-placeholder-${index}`"
        ></div>
      </div>
      <div v-else class="grid items-start gap-4 md:grid-cols-4 md:gap-6">
        <figure
          class="bg-[#fbf8f1] p-3 shadow-[0_18px_50px_rgba(37,45,41,0.12)] transition duration-500 hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(37,45,41,0.16)] sm:p-4"
          :class="featureGridClass(index)"
          v-for="(item, index) in projectsl"
          :key="index"
        >
          <img
            class="h-auto w-full bg-[#eee9df]"
            :src="item"
            :alt="featureAlt(index)"
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import { useStorageFolder } from "@/composables/useStorageAssets";
import { storageFolders } from "@/config/storageSections";

export default {
  setup() {
    const { assets: projectsl, loading } = useStorageFolder(storageFolders.features);
    const featureGridClass = (index) =>
      index === 2 ? "md:col-span-2 md:col-start-2" : "md:col-span-2";

    const featureAlt = (index) => {
      const labels = [
        "PHOSPHENE ARCHITECTS newspaper report",
        "PHOSPHENE ARCHITECTS newspaper report",
        "PHOSPHENE ARCHITECTS certificate",
      ];

      return labels[index] || "PHOSPHENE ARCHITECTS recognition document";
    };

    return { projectsl, loading, featureAlt, featureGridClass };
  },
};
</script>

<style lang="scss" scoped></style>
